exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".src-components-shared-ImagePreview-preview{max-height:200px;max-width:200px;min-width:200px;min-height:200px;background:rgba(0,0,0,.03);color:#929292}.src-components-shared-ImagePreview-previewIcon{font-size:24px}.src-components-shared-ImagePreview-image{max-height:200px;max-width:200px}.src-components-shared-ImagePreview-imageContainer{min-height:200px}", ""]);

// exports
exports.locals = {
	"preview": "src-components-shared-ImagePreview-preview",
	"previewIcon": "src-components-shared-ImagePreview-previewIcon",
	"image": "src-components-shared-ImagePreview-image",
	"imageContainer": "src-components-shared-ImagePreview-imageContainer"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/ImagePreview/styles.scss
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1,"modules":true,"localIdentName":"[path][local]"}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./node_modules/sass-loader/dist/cjs.js!./src/components/shared/ImagePreview/styles.scss
// module chunks = 1